import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export const DeviceContainer = styled(Box)({
	marginLeft: "3rem",
	display: "flex",
	flexDirection: "column",
});

export const MessageScreen = styled(Box)({
	height: "100%",
	width: "100%",
	backgroundColor: "white",
	padding: "0.25rem 1.5rem",
});

export const SmsBubble = styled(Typography)({
	fontSize: "1.25rem",
	borderRadius: "1.15rem",
	lineHeight: 1.25,
	maxWidth: "75%",
	padding: "0.5rem 0.875rem",
	position: "relative",
	wordWrap: "break-word",
	alignItems: "flex-start",
	backgroundColor: "#e5e5ea",
	color: "#000",
	// margin: "0.5rem 0",

	"&::before": {
		bottom: "-0.1rem",
		content: '""',
		height: "1rem",
		position: "absolute",
		borderBottomRightRadius: "0.8rem 0.7rem",
		borderLeft: "1rem solid #e5e5ea",
		left: "-0.35rem",
		transform: "translate(0, -0.1rem)",
	},

	"&::after": {
		bottom: "-0.1rem",
		content: '""',
		height: "1rem",
		position: "absolute",
		backgroundColor: "#fff",
		borderBottomRightRadius: "0.5rem",
		left: "20px",
		transform: "translate(-30px, -2px)",
		width: "10px",
	},
});

export const SmsBubbleWithImage = styled(Typography)({
	fontSize: "1.25rem",
	borderRadius: "1.15rem",
	lineHeight: 1.25,
	maxWidth: "75%",
	padding: "0.5rem 0.875rem",
	position: "relative",
	wordWrap: "break-word",
	alignItems: "flex-start",
	backgroundColor: "#e5e5ea",
	color: "#000",
	margin: "0.5rem 0",

	"&::before": {
		bottom: "-0.1rem",
		content: '""',
		height: "1rem",
		position: "absolute",
		borderBottomRightRadius: "0.8rem 0.7rem",
		borderLeft: "1rem solid #e5e5ea",
		left: "-0.35rem",
		transform: "translate(0, -0.1rem)",
	},

	"&::after": {
		bottom: "-0.1rem",
		content: '""',
		height: "1rem",
		position: "absolute",
		backgroundColor: "#fff",
		borderBottomRightRadius: "0.5rem",
		left: "20px",
		transform: "translate(-30px, -2px)",
		width: "10px",
	},
});

export const ImageAttachmentWithMessage = styled("div")({
	borderRadius: "1.15rem",
	lineHeight: 1.25,
	maxWidth: "75%",
	position: "relative",
	wordWrap: "break-word",
	alignItems: "flex-start",
	backgroundColor: "#f9f9f9",
	color: "#000",
	margin: "0.1rem 0",
});

export const ImageAttachmentWithoutMessage = styled("div")({
	borderRadius: "1.15rem",
	lineHeight: 1.25,
	maxWidth: "75%",
	position: "relative",
	wordWrap: "break-word",
	alignItems: "flex-start",
	backgroundColor: "#f9f9f9",
	color: "#000",
	margin: "0.1rem 0",

	"&::before": {
		bottom: "-0.1rem",
		content: '""',
		height: "1rem",
		position: "absolute",
		borderBottomRightRadius: "0.8rem 0.7rem",
		borderLeft: "1rem solid #f9f9f9",
		left: "-0.35rem",
		transform: "translate(0, -0.1rem)",
	},

	"&::after": {
		bottom: "-0.1rem",
		content: '""',
		height: "1rem",
		position: "absolute",
		backgroundColor: "#fff",
		borderBottomRightRadius: "0.5rem",
		left: "20px",
		transform: "translate(-30px, -2px)",
		width: "10px",
	},
});
